// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Global from "common/src/Global.bs.js";

function TbTeamsSeparator(Props) {
  var hexSize = Props.hexSize;
  var xGridSize = Props.xGridSize;
  var compactMode = Props.compactMode;
  var hs = (hexSize | 0) / 2 | 0;
  var ratio = Math.sin(Math.PI / 6 * 2);
  var horSl = ratio * hexSize;
  var gapSize = (Global.f(xGridSize) - 2 * horSl) / 2;
  var yExtra = gapSize / ratio / 2;
  var y = Global.toFixed(undefined, Global.f(hs) + yExtra);
  var x1 = Global.toFixed(undefined, -gapSize);
  var x2 = Global.toFixed(undefined, horSl);
  var x3 = Global.toFixed(undefined, 2 * horSl + gapSize);
  var x4 = Global.toFixed(undefined, 3 * horSl + 2 * gapSize);
  var x5 = Global.toFixed(undefined, 4 * horSl + 3 * gapSize);
  var x6 = Global.toFixed(undefined, 5 * horSl + 4 * gapSize);
  var x7 = Global.toFixed(undefined, 6 * horSl + 5 * gapSize);
  var x8 = Global.toFixed(undefined, 7 * horSl + 6 * gapSize);
  var x9 = Global.toFixed(undefined, 8 * horSl + 7 * gapSize);
  var x10 = Global.toFixed(undefined, 9 * horSl + 8 * gapSize);
  var x11 = Global.toFixed(undefined, 10 * horSl + 9 * gapSize);
  var x12 = Global.toFixed(undefined, 11 * horSl + 10 * gapSize);
  var x13 = Global.toFixed(undefined, 12 * horSl + 11 * gapSize);
  var x14 = Global.toFixed(undefined, 13 * horSl + 12 * gapSize);
  var x15 = Global.toFixed(undefined, 14 * horSl + 13 * gapSize);
  var x16 = Global.toFixed(undefined, 15 * horSl + 14 * gapSize);
  return React.createElement("path", {
              d: "M " + x1 + " " + y + " " + x2 + " 0 " + x3 + " " + y + " " + x4 + " 0 " + x5 + " " + y + " " + x6 + " 0 " + x7 + " " + y + " " + x8 + " 0 " + x9 + " " + y + " " + x10 + " 0 " + x11 + " " + y + " " + x12 + " 0 " + x13 + " " + y + " " + x14 + " 0 " + x15 + " " + y + " " + x16 + " 0",
              fill: "none",
              stroke: "hsla(196, 100%, 96.8%, 0.4)",
              strokeWidth: "3",
              transform: "translate(0, " + (
                compactMode ? "342.5" : "382.5"
              ) + ")"
            });
}

var make = TbTeamsSeparator;

export {
  make ,
  
}
/* react Not a pure module */
